import script from "./SuccessText.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuccessText.vue?vue&type=script&setup=true&lang=ts"

import "./SuccessText.vue?vue&type=style&index=0&id=4af864ad&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af864ad"]])

export default __exports__